export default __webpack_public_path__ + "static/collaboration-tab-c76898c173159f768e03ccbc527c3035.svg";